module.exports = __webpack_public_path__ + "static/media/fruits_21.bcf7ee0d.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_21.csv
// module id = 686
// module chunks = 0